/*================================================
==================================================
              Fade In animation 
==================================================
================================================*/
const hasScrollablePage =
  document.documentElement.scrollHeight > window.innerHeight + 10;

document.querySelectorAll('.tsb-fade-in').forEach(el => {
  if (!hasScrollablePage) return;

  gsap.fromTo(
    el,
    { opacity: 0, y: 24 },
    {
      opacity: 1,
      y: 0,
      duration: 0.8,
      ease: 'power2.out',
      immediateRender: false,
      scrollTrigger: {
        trigger: el,
        start: 'top 85%',
        once: true
      }
    }
  );
});


/*================================================
==================================================
    The Lookbook menu item to open in new tab
==================================================
================================================*/

document.addEventListener('DOMContentLoaded', function () {

  // Find all navigation links
  var navLinks = document.querySelectorAll('header nav a, .header a, .menu a, footer nav a, .footer a');

  navLinks.forEach(function(link) {

    // Match menu item text
    if (link.textContent.trim() === 'Lookbook') {

      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer');

    }
  });

});